import {
    BlogsAlbumDetailState,
    initialBlogsAlbumDetailState,
} from "@/mk2/apps/blogs/containers/BlogsAlbumDetail/BlogsAlbumDetail.reducers";
import { AppState } from "@/mk2/reducers";

export const getBlogsAlbumDetailState = (
    state: AppState,
    username: string,
    postSlug: string,
): BlogsAlbumDetailState =>
    state.containers.blogs.blogsAlbumDetails[`${username}/${postSlug}`] ||
    initialBlogsAlbumDetailState;
